import type { Translatable } from "../translations/translation";
import { svTranslator } from "../translations/translation";

class TranslatableError extends Error {
    public issues: {
        message: Translatable;
    }[];
    constructor(
        public errorMessage: Translatable,
        public innerError?: Error,
    ) {
        super(svTranslator(errorMessage) || "");
        this.issues = [{ message: errorMessage }];
    }
}

export { TranslatableError };
